import { z } from "zod";
import type { infer as zInfer } from "zod";

export const accountBalance = z.object({
  AVAILABLE: z.number().optional(),
  HOLDING: z.number().optional(),
  PROMOTION_USER: z.number().optional(),
});

export type AccountBalance = zInfer<typeof accountBalance>;
